<template>

  <header class="plex-regular flex flex-col items-center justify-center bg-cover bg-center md:bg-left-top bg-no-repeat "
    :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">

    <div class="flex flex-col items-center py-32 w-full">

      <img class="object-contain w-11/12 md:w-8/12 lg:w-4/12 py-6 md:py-0 mb-5" src="@/assets/feria.png" />

      <div class="flex flex-col md:flex-row gap-3 md:gap-4 mt-10 w-full px-4 text-center md:w-auto">
        <router-link to="/"
          class="px-5 py-2 border border-white bg-gray-100 text-xl text-[#191b26] font-semibold hover:bg-transparent hover:text-white rounded-2xl">
          <i class="pi pi-user mr-2"></i>ACREDITACION PRENSA
        </router-link>

        <router-link to="/credenciales"
          class="px-5 py-2 border border-white bg-gray-100 text-xl text-[#191b26] font-semibold hover:bg-transparent hover:text-white rounded-2xl">
          <i class="pi pi-qrcode mr-2"></i>YA ME ACREDITÉ
        </router-link>


      </div>

    </div>
  </header>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueScrollTo from 'vue-scrollto';

export default defineComponent({
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    }

  },
});

</script>